import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS } from "@/lib/content";

export const FaqList = ({ items = FAQS }) => (
  <Accordion type="single" collapsible className="border-t border-line" data-testid="faq-list">
    {items.map((f, i) => (
      <AccordionItem key={f.q} value={`f${i}`} className="border-b border-line">
        <AccordionTrigger data-testid={`faq-trigger-${i}`} className="font-display py-7 text-left text-lg font-medium text-white hover:no-underline md:text-xl">
          {f.q}
        </AccordionTrigger>
        <AccordionContent className="max-w-2xl pb-7 text-base leading-relaxed text-zinc-300">{f.a}</AccordionContent>
      </AccordionItem>
    ))}
  </Accordion>
);
